// extracted by mini-css-extract-plugin
export default {"Vitrual":"Virtual_Vitrual__ILBCH","left":"Virtual_left__+aHYs","wrapper":"Virtual_wrapper__N8IRo"};